import React from "react";
import Lottie from "react-lottie";
import loaderAnimation from "../assets/animations/loader.json"; // Replace with actual path
import "./loader.css"; // Import the CSS file for animations
import fingerprintLoader from "../assets/animations/impact-loader.svg";

const Loader = ({ loaderType }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true, // animation will autoplay
    animationData: loaderAnimation, // animation JSON data
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="loader">
      {loaderType === "lottie" ? (
        <Lottie options={defaultOptions} height={200} width={200} />
      ) : (
        <img
        src={fingerprintLoader} // Using the imported image here
        alt="Fingerprint Loader"
        className="fingerprint-loader" // Add class for animation
        height={200}
        width={200}
      />
      )}
    </div>
  );
};

export default Loader;
